import { Observable } from 'rxjs';
import { InjectionToken } from '@angular/core';
import { InitMessage } from '../services/base-initialization/init-message';

export interface InitializationInterface {
    isInitialized: boolean;
    initMessages$: Observable<InitMessage[]>;
    checkInit(): Observable<boolean>;
}

export const InitializationInstanceToken = new InjectionToken<InitializationInterface>('InitializationInterface');
